import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../config';
import './DataPage.css';

const styles = {
  page: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
  },
  breadcrumb: {
    fontSize: '13px',
    color: '#999',
    marginBottom: '4px',
  },
  breadcrumbLink: {
    color: '#1976d2',
    textDecoration: 'none',
    cursor: 'pointer',
  },
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '24px',
    flexWrap: 'wrap',
    gap: '12px',
  },
  pageIcon: {
    fontSize: '1.5rem',
    lineHeight: 1,
  },
  pageTitle: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#1a1a2e',
    margin: '0 0 2px 0',
  },
  pageSubtitle: {
    fontSize: '0.85rem',
    color: '#666',
    margin: 0,
  },
  statsRow: {
    display: 'flex',
    gap: '16px',
    marginBottom: '24px',
  },
  statCard: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '20px 24px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    minWidth: '200px',
  },
  statLabel: {
    fontSize: '13px',
    color: '#666',
    margin: '0 0 4px 0',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  statValue: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1976d2',
    margin: 0,
  },
  filtersCard: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    marginBottom: '24px',
    display: 'flex',
    gap: '16px',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
  },
  filterGroup: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: '200px',
  },
  filterLabel: {
    fontSize: '12px',
    color: '#666',
    marginBottom: '6px',
    fontWeight: '500',
  },
  input: {
    padding: '10px 12px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '14px',
    color: '#333',
    outline: 'none',
    transition: 'border-color 0.2s',
    width: '100%',
    boxSizing: 'border-box',
  },
  select: {
    padding: '10px 12px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '14px',
    color: '#333',
    outline: 'none',
    backgroundColor: '#fff',
    cursor: 'pointer',
    width: '100%',
    boxSizing: 'border-box',
  },
  clearBtn: {
    padding: '10px 20px',
    backgroundColor: '#f5f5f5',
    color: '#666',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '14px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'background-color 0.2s',
  },
  tableCard: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    overflow: 'hidden',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px',
  },
  th: {
    padding: '14px 16px',
    textAlign: 'left',
    backgroundColor: '#fafafa',
    color: '#555',
    fontWeight: '600',
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    borderBottom: '2px solid #eee',
    cursor: 'pointer',
    userSelect: 'none',
    whiteSpace: 'nowrap',
  },
  td: {
    padding: '12px 16px',
    borderBottom: '1px solid #f0f0f0',
    color: '#333',
  },
  rowEven: {
    backgroundColor: '#fff',
  },
  rowOdd: {
    backgroundColor: '#fafafa',
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '60px',
    color: '#666',
    fontSize: '16px',
  },
  emptyState: {
    textAlign: 'center',
    padding: '60px 20px',
    color: '#999',
  },
  emptyTitle: {
    fontSize: '18px',
    fontWeight: '500',
    color: '#666',
    margin: '0 0 8px 0',
  },
  emptyText: {
    fontSize: '14px',
    color: '#999',
    margin: 0,
  },
  materialBadge: {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: '500',
    backgroundColor: '#e3f2fd',
    color: '#1565c0',
  },
};

function Recipientes() {
  const [recipientes, setRecipientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [materialFilter, setMaterialFilter] = useState('');
  const [materiaisUnicos, setMateriaisUnicos] = useState([]);
  const [sortBy, setSortBy] = useState('DESCRICAO');
  const [sortOrder, setSortOrder] = useState('ASC');

  useEffect(() => {
    fetchRecipientes();
  }, [search, materialFilter]);

  const fetchRecipientes = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (materialFilter) params.append('material', materialFilter);

      const response = await axios.get(`${API_URL}/recipientes?${params.toString()}`);
      const data = Array.isArray(response.data) ? response.data : (response.data.data || []);
      setRecipientes(data);

      // Extrair materiais unicos para o filtro (somente na primeira carga ou quando sem filtro)
      if (!materialFilter && !search) {
        const materiais = [...new Set(data.map(r => r.MATERIAL).filter(Boolean))].sort();
        setMateriaisUnicos(materiais);
      } else if (!materialFilter) {
        // Se tem busca mas nao tem filtro de material, atualizar materiais disponiveis
        const materiais = [...new Set(data.map(r => r.MATERIAL).filter(Boolean))].sort();
        setMateriaisUnicos(prev => prev.length > 0 ? prev : materiais);
      }
    } catch (err) {
      console.error('Erro ao buscar recipientes:', err);
      setRecipientes([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortOrder(prev => prev === 'ASC' ? 'DESC' : 'ASC');
    } else {
      setSortBy(field);
      setSortOrder('ASC');
    }
  };

  const getSortIcon = (field) => {
    if (sortBy !== field) return ' \u2195';
    return sortOrder === 'ASC' ? ' \u2191' : ' \u2193';
  };

  const sortedRecipientes = [...recipientes].sort((a, b) => {
    const valA = a[sortBy] || '';
    const valB = b[sortBy] || '';
    if (typeof valA === 'number' && typeof valB === 'number') {
      return sortOrder === 'ASC' ? valA - valB : valB - valA;
    }
    const strA = String(valA).toLowerCase();
    const strB = String(valB).toLowerCase();
    if (strA < strB) return sortOrder === 'ASC' ? -1 : 1;
    if (strA > strB) return sortOrder === 'ASC' ? 1 : -1;
    return 0;
  });

  const hasFilters = search || materialFilter;

  return (
    <div className="data-page" style={styles.page}>
      {/* Breadcrumb */}
      <div style={styles.breadcrumb}>
        <span style={styles.breadcrumbLink}>Inicio</span>
        <span> / </span>
        <span>Recipientes</span>
      </div>

      {/* Header */}
      <div style={styles.pageHeader}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={styles.pageIcon}>🧪</span>
          <div>
            <h1 style={styles.pageTitle}>Recipientes</h1>
            <p style={styles.pageSubtitle}>
              Gerenciamento de recipientes e tubos do laboratorio
            </p>
          </div>
        </div>
      </div>

      {/* Contadores */}
      <div className="responsive-flex" style={styles.statsRow}>
        <div style={styles.statCard}>
          <p style={styles.statLabel}>Total de Recipientes</p>
          <p style={styles.statValue}>{sortedRecipientes.length}</p>
        </div>
      </div>

      {/* Filtros */}
      <div className="responsive-flex page-filters" style={styles.filtersCard}>
        <div style={styles.filterGroup}>
          <label style={styles.filterLabel}>Buscar por descricao</label>
          <input
            type="text"
            placeholder="Digite para buscar..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={styles.input}
          />
        </div>
        <div style={styles.filterGroup}>
          <label style={styles.filterLabel}>Material</label>
          <select
            value={materialFilter}
            onChange={(e) => setMaterialFilter(e.target.value)}
            style={styles.select}
          >
            <option value="">Todos os materiais</option>
            {materiaisUnicos.map(mat => (
              <option key={mat} value={mat}>{mat}</option>
            ))}
          </select>
        </div>
        {hasFilters && (
          <button
            style={styles.clearBtn}
            onClick={() => {
              setSearch('');
              setMaterialFilter('');
            }}
            onMouseEnter={(e) => { e.target.style.backgroundColor = '#eee'; }}
            onMouseLeave={(e) => { e.target.style.backgroundColor = '#f5f5f5'; }}
          >
            Limpar Filtros
          </button>
        )}
      </div>

      {/* Tabela */}
      <div style={styles.tableCard}>
        {loading ? (
          <div style={styles.loading}>Carregando recipientes...</div>
        ) : sortedRecipientes.length === 0 ? (
          <div style={styles.emptyState}>
            <p style={styles.emptyTitle}>Nenhum recipiente encontrado</p>
            <p style={styles.emptyText}>
              {hasFilters
                ? 'Tente ajustar os filtros de busca.'
                : 'Nenhum recipiente cadastrado no sistema.'}
            </p>
          </div>
        ) : (
          <div style={styles.tableWrapper}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th} onClick={() => handleSort('ID')}>
                    ID{getSortIcon('ID')}
                  </th>
                  <th style={{ ...styles.th, minWidth: '300px' }} onClick={() => handleSort('DESCRICAO')}>
                    Descricao{getSortIcon('DESCRICAO')}
                  </th>
                  <th style={styles.th} onClick={() => handleSort('MATERIAL')}>
                    Material{getSortIcon('MATERIAL')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedRecipientes.map((recipiente, index) => (
                  <tr
                    key={recipiente.ID}
                    style={{
                      ...(index % 2 === 0 ? styles.rowEven : styles.rowOdd),
                      transition: 'background-color 0.15s',
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#e8f0fe'; }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#fff' : '#fafafa';
                    }}
                  >
                    <td style={styles.td}>{recipiente.ID}</td>
                    <td style={styles.td}>{recipiente.DESCRICAO || '-'}</td>
                    <td style={styles.td}>
                      {recipiente.MATERIAL ? (
                        <span style={styles.materialBadge}>{recipiente.MATERIAL}</span>
                      ) : (
                        '-'
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default Recipientes;
